module.exports = __webpack_public_path__ + "img/alcaldia-logo-texto.c4e2d776.svg";